import React from "react";

import { Skeleton } from "../../UI/Skeleton";
import { Typography } from "../../UI/Typography";
import { Box } from "../../UI/Box";
import { COLOR_SOLITUDE } from "../../constants/styles";

interface IProps {
  isLoading: boolean;
  label: string;
  detail?: string | number | null;
  isHighlighted?: boolean;
}

export const UserDetail: React.FC<IProps> = (props) => (
  <>
    {!props.isLoading && (props.detail || props.detail === "")  && (
      <Typography>
        {props.isHighlighted && (
          <Box
            component="span"
            bgcolor={props.isHighlighted ? COLOR_SOLITUDE : "transparent"}
            px={1.5}
            mx={-1.5}
            borderRadius={1}
          >
            <Box component="span" fontWeight={600}>
              {props.label}
            </Box>{" "}
            {props.detail === ""? "N/A" : props.detail}
          </Box>
        )}
        {!props.isHighlighted && (
          <>
            <Box component="span" fontWeight={600} bgcolor={props.isHighlighted ? COLOR_SOLITUDE : "transparent"}>
              {props.label}
            </Box>{" "}
            {props.detail === ""? "N/A" : props.detail}
          </>
        )}
      </Typography>
    )}
    {props.isLoading && <Skeleton width={250} variant="text" />}
  </>
);
